import { Button, Form, Modal } from "antd";
import { useEffect, useState } from "react";
import CommonInput from "../../../Common/CommonInput";
import { useDispatch, useSelector } from "react-redux";
import { dispatchtoast, getLocalStorageItem } from "../../../Utils";
import { checkStatus, getRezorAddfund, getRezorVerify } from "./AddFundApi";
import { useLocation, useNavigate } from "react-router-dom";
import { setselectedTab } from "../../../Store/B2bslice";
import { Images } from "../../../Controller";
import { ThemeColor } from "../../../Theme/theme";

const AddFund = () => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [selectedTab, setSelectedTabb] = useState();
  const [loading, setLoading] = useState(false);
  const [response, setResponse] = useState(null);
  const navigate = useNavigate();
  const queryString = useLocation().search;
  const urlParams = new URLSearchParams(queryString);
  const memberServices = useSelector((state) => state.B2B.memberServices);
  const [isOpenModal, setIsOpenModal] = useState(false);
  const clientTxnId = urlParams.get("clientTxnId");
  const paidAmount = parseFloat(urlParams.get("paidAmount"));

  const status = urlParams.get("status");

  useEffect(() => {
    dispatch(setselectedTab("1000"));
    if (!memberServices.includes("102")) {
      navigate("/not-Available");
    }
  }, []);
  useEffect(() => {
    if (clientTxnId) {
      checkStatus({
        paidAmount,
        clientTxnId,
        status,
      })
        .then((res) => {
          if (res.status) {
            dispatchtoast(res.message);
            navigate("/add-fund", { replace: true });
            setTimeout(() => {
              window.location.reload();
            }, 2000);
          }
        })
        .catch((err) => console.log(err));
    }
  }, [urlParams]);

  const handleFinishRezor = (val) => {
    setLoading(true);
    const formdata = new FormData();
    formdata.append("amount", val.amount);
    formdata.append("latitude", getLocalStorageItem("latitude"));
    formdata.append("longitude", getLocalStorageItem("longitude"));
    getRezorAddfund(formdata)
      .then((res) => {
        if (res.status) {
          var options = {
            key: res.request_data.payment_request_data.key,
            amount: res.request_data.payment_request_data.amount, // Amount is in currency subunits. Default currency is INR. Hence, 50000 refers to 50000 paise
            currency: "INR",
            name: "Join2Pay",
            description: "Transaction",
            image: Images.WebsiteSmallLogo,
            order_id: res.request_data.payment_request_data.order_id ?? "",
            handler: (response) => {
              setLoading(true);
              getRezorVerify({
                razorpay_payment_id: response.razorpay_payment_id,
                merchant_order_id: response.razorpay_order_id,
                razorpay_signature: response.razorpay_signature,
              })
                .then((res) => {
                  if (res.status) {
                    dispatchtoast(res.message);
                    form.resetFields();
                  }
                })
                .catch((err) => {
                  console.log(err);
                })
                .finally(() => setLoading(false));
            },
            prefill: {
              name: res.request_data.payment_request_data.prefill?.name, //vendor name
              email: res.request_data.payment_request_data.prefill?.email, //vendor email
              contact: res.request_data.payment_request_data.prefill?.contact, //"9000090000" //vendor contact
            },
            theme: {
              color: ThemeColor?.primary,
            },
          };
          const rzp = new window.Razorpay(options);
          rzp.open();
        }
      })
      .catch((err) => console.log(err))
      .finally(() => setLoading(false));
  };

  return (
    <>
      <div className="grid grid-cols-1 place-items-start gap-8">
        <p
          onClick={() => (setSelectedTabb(0), setResponse(null))}
          // className={` ${
          //   selectedTab === 0 ? "bg-primary text-white" : "bg-white text-black"
          // }  flex justify-center items-center cursor-pointer  h-10 w-1/4 rounded-2xl`}
          className={
            "bg-primary text-white text-sm lg:text-lg  flex justify-center items-center cursor-pointer  font-semibold h-10 w-full md:w-1/4 rounded-3xl"
          }
        >
          RAZORPAY PAYMENT
          {/* 2.48% */}
        </p>
      </div>

      <div className="bg-white p-3 mt-4 rounded-md">
        <p className="font-bold">Add Fund </p>
        <Form form={form} onFinish={handleFinishRezor}>
          <div className="flex justify-start mt-4 items-center gap-5">
            <Form.Item name={"amount"}>
              <CommonInput placeholder={"Enter Amount"} />
            </Form.Item>
            <Button
              loading={loading}
              type="primary"
              htmlType="submit"
              className="bg-primary text-white border-none"
            >
              Submit
            </Button>
          </div>
        </Form>
      </div>

      {isOpenModal && (
        <Modal
          title="Payment"
          footer={null}
          width={300}
          maskClosable={false}
          open={isOpenModal}
          onCancel={() => setIsOpenModal(false)}
        >
          <div className="text-center">
            <p>Opening secure checkout…</p>
          </div>
        </Modal>
      )}
    </>
  );
};

export default AddFund;
